import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint } from './parts/sideParts'
import { verticalPartsForWithEdge, verticalPartsOfWeb, verticalPartsOfWebWithCenterStitch } from './parts/verticalParts'

export const crossWeb = (ctx: CanvasRenderingContext2D, edgeColor: string, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsForWithEdge(ctx, webColor, stitchColor)
  // ヘリ革左ここから
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(250, 212) // 上＿外
  ctx.quadraticCurveTo(273, 285, 313, 355) // 左＿下
  ctx.quadraticCurveTo(316, 346, 316, 346) // 下＿内
  ctx.quadraticCurveTo(275, 267, 256, 203) // 上＿内
  ctx.quadraticCurveTo(250, 212, 250, 212) // 上＿外
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革右ここから
  ctx.beginPath()
  ctx.moveTo(287, 163) // 上＿内
  ctx.quadraticCurveTo(301, 229, 339, 314) // 下＿内
  ctx.quadraticCurveTo(342, 307, 344, 307) // 右＿下
  ctx.quadraticCurveTo(313, 241, 293, 150) // 上＿外
  ctx.quadraticCurveTo(287, 163, 287, 163) // 上＿内
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革ここまで

  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
}

export const crossWebCenterStitch = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWebWithCenterStitch(ctx, webColor, stitchColor)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
}

export const crossWebWithEdge = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  edgeColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWeb(ctx, webColor, stitchColor)
  // ヘリ革左ここから
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(250, 212) // 上＿外
  ctx.quadraticCurveTo(273, 285, 310, 351) // 左＿下
  ctx.quadraticCurveTo(314, 343, 314, 343) // 下＿内
  ctx.quadraticCurveTo(275, 267, 257, 205) // 上＿内
  ctx.quadraticCurveTo(250, 212, 250, 212) // 上＿外
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革右ここから
  ctx.beginPath()
  ctx.moveTo(287, 163) // 上＿内
  ctx.quadraticCurveTo(301, 229, 338, 310) // 下＿内
  ctx.quadraticCurveTo(343, 302, 343, 302) // 右＿下
  ctx.quadraticCurveTo(313, 241, 293, 150) // 上＿外
  ctx.quadraticCurveTo(287, 163, 287, 163) // 上＿内
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革ここまで
  // stitchここから
  ctx.lineWidth = 1.1
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 縦＿左
  ctx.moveTo(259, 204) // 上
  ctx.quadraticCurveTo(281, 276, 314, 339) // 下
  // 縦＿右
  ctx.moveTo(286, 166) // 上
  ctx.quadraticCurveTo(300, 238, 337, 312) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
}

export const crossJointWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWeb(ctx, webColor, stitchColor)

  // stitchここから
  ctx.lineWidth = 1.1
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 縦＿左
  ctx.moveTo(259, 204) // 上
  ctx.quadraticCurveTo(281, 276, 314, 339) // 下
  // 縦＿右
  ctx.moveTo(286, 166) // 上
  ctx.quadraticCurveTo(300, 238, 332, 305) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // ウェブ先端
  topSidePartOfWebWithJoint(ctx, webColor, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, webColor, stitchColor, 17, 32)
}
